<script lang="ts">
	import { devices_settings } from 'src/stores';
	import { onMount } from 'svelte';
	import { Toggle, toast } from '@Shelly/shelly-design-system';
	import {
		getWaveCoverComponentId,
		zwaveCoverGetConfig,
		zwaveCoverSetConfig,
	} from 'src/helpers/z_wave_cover_helpers';
	import { real_id } from 'src/helpers/interface_helpers';
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { capFirstChar } from 'src/helpers/utilities';
	import type { InputClickEvent } from 'src/types/InputClickEvent';
	import { format } from 'svelte-i18n';

	export let device;

	const id = real_id(device.id);

	let settings = readDeviceSettings(id);
	let inverted = false;
	let loading = false;
	let lastSynced: boolean | undefined;

	$: componentId = getWaveCoverComponentId(device);
	$: coverKey = `cover:${componentId}`;
	$: settings = $devices_settings?.[real_id(id)];
	$: storedValue = settings?.[coverKey]?.invert_directions;
	$: if (typeof storedValue === 'boolean' && lastSynced !== storedValue && !loading) {
		lastSynced = storedValue;
		inverted = storedValue;
	}

	const sentRequest = async (e: InputClickEvent) => {
		loading = true;
		inverted = e.target.checked;

		const res = await zwaveCoverSetConfig(device, {
			invert_directions: inverted,
		});

		if (res.isok) {
			toast.open({
				type: 'success',
				title: $format('reverse_directions_scc_toast', {
					default: 'Directions reversed successfully.',
				}),
			});
			lastSynced = inverted;
		} else {
			toast.open({ type: 'danger', title: $format('setting_err_toast') });
			inverted = !inverted;
		}
		loading = false;
	};

	onMount(async () => {
		if (typeof storedValue === 'boolean') {
			return;
		}
		await zwaveCoverGetConfig(device);
	});
</script>

<Toggle
	disabled={loading}
	checked={inverted}
	size="m"
	on:click={sentRequest}
	id="toggle-wave-invert-cover"
>
	{capFirstChar(
		$format('invert_output_label', {
			default: 'Invert output logic',
		}),
	)}
</Toggle>
